import React, { useState, useEffect, useContext } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../hooks/useBranding';
import { BracketAccessContext } from '../App';

export default function Layout() {
  const { currentUser, userProfile, isAdmin, logout } = useAuth();
  const branding = useBranding();
  const navigate = useNavigate();
  const location = useLocation();
  const { hasBracket, pastDeadline } = useContext(BracketAccessContext);
  const hasAccess = isAdmin || hasBracket || userProfile?.isObserver;
  const needsBracket = location.state?.needsBracket;
  const [showPayout, setShowPayout] = useState(false);
  const [scoresEnabled, setScoresEnabled] = useState(true);

  useEffect(() => {
    const API_BASE = process.env.REACT_APP_API_URL || '/api';
    fetch(`${API_BASE}/payout-config`)
      .then(r => r.json())
      .then(cfg => setShowPayout(!!cfg.enabled))
      .catch(() => {});
    fetch(`${API_BASE}/scores/config`)
      .then(r => r.json())
      .then(cfg => setScoresEnabled(cfg.scoresEnabled !== false))
      .catch(() => {});
  }, []);

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  return (
    <div className="layout">
      <nav className="navbar">
        <NavLink to="/" className="navbar-brand">
          {branding.logoUrl
            ? <img src={branding.logoUrl} alt="logo" style={{ height: 32, width: 32, objectFit: 'contain', borderRadius: 4 }} />
            : <span style={{ fontSize: '1.4rem' }}>🏀</span>
          }
          {branding.poolName ? (
            <>
              {branding.poolName.split(' ').slice(0, -1).join(' ').toUpperCase()}{' '}
              <span>{branding.poolName.split(' ').pop().toUpperCase()}</span>
            </>
          ) : <> MARCH <span>MADNESS</span></>}
        </NavLink>
        <div className="navbar-links">
          <NavLink to="/" end className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
            Dashboard
          </NavLink>
          {hasAccess && (
            <NavLink to="/leaderboard" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
              Leaderboard
            </NavLink>
          )}
          {hasAccess && scoresEnabled && (
            <NavLink to="/scores" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
              Scores
            </NavLink>
          )}
          {hasAccess && showPayout && (
            <NavLink to="/payout" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
              Payout
            </NavLink>
          )}
          {hasAccess && (
            <NavLink to="/archive" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
              Archive
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/admin" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
              ⚙️ Admin
            </NavLink>
          )}
        </div>
        <div className="navbar-user">
          <span className="user-name">{userProfile?.displayName || currentUser?.email}</span>
          <button className="btn btn-secondary btn-sm" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </nav>
      {needsBracket && !hasAccess && (
        <div className="alert alert-info" style={{ borderRadius: 0, margin: 0, padding: '10px 24px', display: 'flex', alignItems: 'center', gap: 10, borderLeft: 'none', borderRight: 'none', borderTop: 'none' }}>
          <span style={{ fontSize: '1.1rem' }}>🏀</span>
          <span>Submit a bracket to unlock the Leaderboard, Scores, and more!</span>
          <NavLink to="/bracket/new" className="btn btn-primary btn-sm" style={{ marginLeft: 'auto', fontSize: '0.82rem' }}>
            Create Bracket →
          </NavLink>
        </div>
      )}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
